import { createIntl, createIntlCache, MessageDescriptor } from '@formatjs/intl';
import i18next from 'i18next';

import en from 'date-fns/locale/en-US';

const cache = createIntlCache();
const intl = createIntl(
  {
    locale: 'en-US',
    messages: {
      'components.transaction_status': 'Success',
    },
  },
  cache
);

export const formatCurrency = (
  value: number | string,
  code: string,
  {
    precision,
  }: {
    precision?: number;
  } = {}
): string => {
  return intl.formatNumber(value as number, {
    style: 'currency',
    currency: code,
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  });
};

export const formatTimestamp = (value: string): string => {
  const date = new Date(value);
  const locale = i18next.language || 'en';
  const nativeIntl = new Intl.DateTimeFormat(locale, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    timeZoneName: 'short',
  });

  return `${nativeIntl.format(date)}`;
};

export enum HashLength {
  FULL = 0,
  TINY = 5,
  LITTLE = 10,
  SMALL = 15,
  MEDIUM = 20,
  LARGE = 25,
}
